import { FormSuccess } from '../../../components/FormSuccess'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'

export default function PersonnelMovementRequestsCompletePage() {
  return (
    <PublicFormLayout title="Movimentação de Pessoal">
      <FormSuccess
        title="Solicitação de Movimentação de Pessoal Concluída!"
        description="Obrigado pelo preenchimento Magenta!"
        notes={[
          'Agora que você já concluiu a primeira etapa, basta aguardar que em até 3 dias úteis um de nós do time de RH irá entrar em contato com você para realizar uma reunião sobre sua solicitação de movimentação de pessoal.',
          '#ABRACEVAI \\o/'
        ]}
        actions={[
          { label: 'Retornar para página inicial', to: '/personnel-movement', loggedOnly: true },
          { label: 'Realizar uma nova Solicitação de Movimentação de Pessoal', to: '/personnel-movement/new' }
        ]}
      />
    </PublicFormLayout>
  )
}
